import { h2Style, subtitleStyle } from './tokens';

export default function EmptyState({ title, copy, ctaLabel, onCta, testid }) {
  return (
    <div style={{
      background: 'rgba(255,255,255,.94)', border: '1px dashed rgba(0,0,0,.10)',
      borderRadius: 18, padding: '28px 20px', textAlign: 'center', marginBottom: 24,
    }} data-testid={testid}>
      <h3 style={{ ...h2Style, fontSize: 17, marginBottom: 8 }}>{title}</h3>
      <p style={{ ...subtitleStyle, marginTop: 0, marginBottom: ctaLabel ? 14 : 0 }}>{copy}</p>
      {ctaLabel && onCta && (
        <button onClick={onCta} data-testid={`${testid}-cta`} style={{
          padding: '10px 18px', borderRadius: 999, border: '1px solid rgba(109,94,245,.30)',
          background: 'rgba(109,94,245,.08)', color: '#6D5EF5', fontSize: 12.5, fontWeight: 700,
          cursor: 'pointer', fontFamily: 'inherit',
        }}>{ctaLabel}</button>
      )}
    </div>
  );
}
